var exports = {
  "kL": "x234b8571--603130--container",
  "UU": "x234b8571--603130--icon-img",
};

module.exports = exports;
